import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface ChatHeaderContainerProps {
  children: ReactNode;
  className?: string;
}

export const ChatHeaderContainer: FC<ChatHeaderContainerProps> = ({
  children,
  className,
}) => (
  <div
    className={cx(
      "flex h-16 w-full shrink-0 items-center justify-between gap-2 border-b border-l-0 border-r-0 border-t-0 border-solid border-[#F2F2F2] bg-white px-4",
      className
    )}
  >
    {children}
  </div>
);
